var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadSourceData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E8EBFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.5L20 17.75M20 17.75L23 20.75M20 17.75L17 20.75M14.75 27.5C12.2647 27.5 10.25 25.4853 10.25 23C10.25 21.0071 11.5456 19.3167 13.3404 18.7252C13.281 18.4092 13.25 18.0832 13.25 17.75C13.25 14.8505 15.6005 12.5 18.5 12.5C20.9312 12.5 22.9765 14.1526 23.5737 16.3957C23.8654 16.3011 24.1767 16.25 24.5 16.25C26.1569 16.25 27.5 17.5931 27.5 19.25C27.5 19.5981 27.4407 19.9324 27.3316 20.2433C28.7453 20.7805 29.75 22.1479 29.75 23.75C29.75 25.8211 28.0711 27.5 26 27.5H14.75Z",
    stroke: "#120A8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSourceData);
export default __webpack_public_path__ + "static/media/upload-source-data.736836cdd79aeadd086c1679a551c5e7.svg";
export { ForwardRef as ReactComponent };